import { render, staticRenderFns } from "./travelingComputers.vue?vue&type=template&id=1755fd47&scoped=true&"
import script from "./travelingComputers.vue?vue&type=script&lang=js&"
export * from "./travelingComputers.vue?vue&type=script&lang=js&"
import style0 from "./travelingComputers.vue?vue&type=style&index=0&id=1755fd47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1755fd47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VImg,VLayout,VRow,VSpacer,VTextField,VTextarea})
